import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { RivhitDataProvider } from './context/RivhitDataContext';
import { ModulesProvider } from './context/ModulesContext';
import { useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ModuleRoute from './components/ModuleRoute';
import Layout from './components/Layout';
import Landing from './pages/Landing';
import Settings from './pages/Settings';
import Orders from './pages/Orders';
import Documents from './pages/Documents';
import CreateDocument from './pages/CreateDocument';
import Reports from './pages/Reports';
import Customers from './pages/Customers';
import Automations from './pages/Automations';
import Notifications from './pages/Notifications';
import Items from './pages/Items';
import Overview from './pages/Overview';
import Signals from './pages/Signals';
import Conversations from './pages/Conversations';
import Reminders from './pages/Reminders';
import Entities from './pages/Entities';
import Invoicing from './pages/Invoicing';
import CreatePayment from './pages/CreatePayment';
import Collections from './pages/Collections';
import PaymentLinks from './pages/PaymentLinks';
import Modules from './pages/Modules';
import PublicPaymentRequest from './pages/PublicPaymentRequest';
import PublicMobileCheckout from './pages/PublicMobileCheckout';
import ShortLinkRedirect from './pages/ShortLinkRedirect';
import Simulator from './pages/Simulator';
import Home from './pages/Home';
import Bugs from './pages/Bugs';
import McpConnect from './pages/McpConnect';
import Reconciliation from './pages/Reconciliation';

function TenantScopedAppShell() {
  const { user } = useAuth();
  const tenantKey = user?.tenant_id || 'no-tenant';

  return (
    <ModulesProvider key={`modules-${tenantKey}`}>
      <RivhitDataProvider key={`rivhit-${tenantKey}`}>
        <Layout />
      </RivhitDataProvider>
    </ModulesProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
            {/* Public route */}
            <Route path="/" element={<Landing />} />
            <Route path="/mcp/connect" element={<McpConnect />} />
            <Route path="/pay/r/:token" element={<PublicPaymentRequest />} />
            <Route path="/pay/q/:token" element={<PublicMobileCheckout />} />
            <Route path="/s/:code" element={<ShortLinkRedirect />} />
            <Route
              path="/simulator"
              element={
                <ProtectedRoute>
                  <Simulator />
                </ProtectedRoute>
              }
            />

            {/* Protected routes inside Layout */}
            <Route
              element={
                <ProtectedRoute>
                  <TenantScopedAppShell />
                </ProtectedRoute>
              }
            >
              <Route path="/home" element={<Home />} />
              <Route path="/orders" element={<ModuleRoute moduleId="orders"><Orders /></ModuleRoute>} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/automations" element={<Automations />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/items" element={<Items />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/reports" element={<ModuleRoute moduleId="analytics"><Reports /></ModuleRoute>} />
              <Route path="/create-document" element={<CreateDocument />} />
              <Route path="/create-payment" element={<CreatePayment />} />
              <Route path="/overview" element={<Overview />} />
              <Route path="/signals" element={<Signals />} />
              <Route path="/conversations" element={<Conversations />} />
              <Route path="/reminders" element={<Reminders />} />
              <Route path="/entities" element={<Entities />} />
              <Route path="/invoicing" element={<Invoicing />} />
              <Route path="/collections" element={<ModuleRoute moduleId="collections"><Collections /></ModuleRoute>} />
              <Route path="/payment-links" element={<ModuleRoute moduleId="collections"><PaymentLinks /></ModuleRoute>} />
              <Route path="/reconciliation" element={<Reconciliation />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/modules" element={<Modules />} />
              <Route path="/bugs" element={<Bugs />} />
            </Route>

            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
